import './App.css';
import Calculator from './components/Calculator'

function App() {
  return (
    <div className="App">
      <Calculator/> 
    </div>
  );
}

export default App;
